var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger"},[_vm._v(" There was a problem loading this page. Please try reloading it. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }